import { G } from '@mobily/ts-belt';
import { Box, Stack, Text } from '@stitch-fix/mode-react';
import { useCopy } from '../../utils/contexts/copy-provider';
import { SearchFragment } from '../../utils/hooks/getSearchResults';
import { useSearchParams } from '../../utils/hooks/useSearchParams';
import CorrectedQuery from '../CorrectedQuery';
import MoreCategories from '../MoreCategories';
interface NoResultsProps {
  search: SearchFragment;
}
const NoResults = ({
  search
}: NoResultsProps) => {
  const {
    copy
  } = useCopy();
  const {
    queryParams
  } = useSearchParams();
  const {
    correctedQuery
  } = search;
  return <Stack spacing={{
    sm: 1.5,
    md: 3
  }} divider="subtle">
      <Box>
        <Text setting="title-medium" align={{
        sm: 'left',
        md: 'center'
      }} spacingBottom>
          {copy.emptyResultsTextPrefix} &ldquo;{queryParams.q}&rdquo;
        </Text>
        {G.isString(correctedQuery) ? <CorrectedQuery correction={correctedQuery} /> : <Text setting="body-small" align={{
        sm: 'left',
        md: 'center'
      }}>
            {copy.emptyResultsTitle}
          </Text>}
      </Box>

      <MoreCategories moreCategories={search.moreCategories} />
    </Stack>;
};
export default NoResults;